export default __webpack_public_path__ + "static/media/check_black.cc34e2da.svg";